function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, React.createElement("path", {
  d: "M22.92,2.85,20.8.73a2.52,2.52,0,0,0-3.54,0L1.92,16.08h0l-.25.25a.56.56,0,0,0-.13.24L0,23a.49.49,0,0,0,.14.47.5.5,0,0,0,.35.14H.61l6.47-1.52A.56.56,0,0,0,7.32,22l.24-.25h0l13.2-13.2h0v0L22.21,7.1h0l.7-.7A2.5,2.5,0,0,0,22.92,2.85ZM20.44,7.46,16.2,3.21l.71-.71,4.24,4.24ZM7.22,20.68,3,16.43,15.49,3.91l4.24,4.26ZM2.39,17.27l4,4L1.17,22.48ZM22.21,5.68,21.86,6,17.62,1.79,18,1.44a1.49,1.49,0,0,1,2.12,0l2.12,2.12A1.49,1.49,0,0,1,22.21,5.68Z"
})));

var SvgEdit = function SvgEdit(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 23.65 23.65",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/edit.61640e38.svg";
export { ForwardRef as ReactComponent };